/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import { useContext } from "react";
import { useTranslator } from "@jutro/locale";
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

// eslint-disable-next-line import/no-unresolved
import appConfig from "app-config";
import _ from "lodash";
import messages from "./MLBillingUtil.messages";

function MLBillingUtil() {
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();

    const ratingPaymentMethodTypelist = viewModelService.productMetadata
        .get("pc")
        .types.getTypelist("RatingPaymentMethod_ML");

    const { mlRatingConfigs, mlPaymentPlan, portalCode } = appConfig;
    const qnbMode = (portalCode === 'QB');
    

    const {
        MLRatingForAnnualPayment,
        MLRatingForMortgageePayment,
        MLRatingForMonthlyPayment,
        MLRatingForMonthlyPayrollDeductPayment,
        MLRatingForAnnualPayrollDeductPayment,
    } = mlRatingConfigs;

    const {
        MLAnnuallyPayPlanPublicId,
        MLMortgageePayPlanPublicId,
        MLMonthlyPayPlanPublicId,
        MLMonthlyAnnualResponsivePlanPublicId,
        MLMonthlySemiAnnualResponsivePlanPublicId,
        MLTwicePerMonthPayPlanPublicId,
        MLTwoPayAnnualPlanPublicId,
        MLTwoPaySemiAnnualPlanPublicId,
        MLFourPayAnnualPlanPublicId,
        MLPayrollDeductPlanPublicId,
    } = mlPaymentPlan;

    const MLAccountPaymentMethods = {
        CREDIT_CARD: "creditcard",
        BANK_ACCOUNT: "ach",
        RESPONSIVE: "responsive",
        PAYROLL_DEDUCT: "payrolldeduct_ml",
    };

    const MLRatingPaymentMethods = {
        CREDIT_CARD: "credit_debit_card",
        BANK_ACCOUNT: "bank_account",
        PAYROLL_DEDUCT: "payroll_deduction",
        MORTGAGEE: "mortgagee",
        PAY_ONLINE_OR_BY_MAIL: "check",
    };

    const MLPaymentChannels = {
        AGENT_PHONE: "AgentPhone",
        CUSTOMER_PORTAL: "CustomerPortal",
        AGENT_IN_PERSON: "AgentInPerson",
        AGENT: "Agent",
        AGENCY_SWEEP: "AgencySweep",
        CUSTOMER_SERVICE: "CustomerService",
    };

    const _getRatingPaymentMethods = () => {
        return MLRatingPaymentMethods;
    };

    const _getAccountPaymentMethods = () => {
        return MLAccountPaymentMethods;
    };

    const _getPaymentChannels = () => {
        return MLPaymentChannels;
    };

    // RatingPaymentMethod_ML.tti
    const RatingPaymentMethodDescriptionMap = [
        {
            code: "credit_debit_card",
            desc: translator(messages.ratingPaymentMethodCreditCard),
        },
        {
            code: "bank_account",
            desc: translator(messages.ratingPaymentMethodBankAccount),
        },
        {
            code: "mortgagee",
            desc: translator(messages.ratingPaymentMethodMortgagee),
        },
        { code: "check", desc: translator(messages.ratingPaymentMethodCheck) },
        {
            code: "payroll_deduction",
            desc: qnbMode ?  translator(messages.ratingPaymentMethodBankPayrollDeductionQNB) : translator(messages.ratingPaymentMethodBankPayrollDeduction),
        },
    ];

    const RatingDownPaymentMethodDescriptionMap = [
        {
            code: "credit_debit_card",
            desc: translator(messages.ratingDownPaymentMethodCreditCard),
        },
        {
            code: "bank_account",
            desc: translator(messages.ratingDownPaymentMethodBankAccount),
        },
        {
            code: "mortgagee",
            desc: translator(messages.ratingPaymentMethodMortgagee),
        },
        { code: "check", desc: translator(messages.ratingPaymentMethodCheck) },
        {
            code: "payroll_deduction",
            desc: translator(messages.ratingDownPaymentMethodBankPayrollDeduction),
        },
    ];

    const _getPaymentMethodName = (code) => {
        return _.find(RatingPaymentMethodDescriptionMap, { code: code }).desc;
    };

    const _getDownPaymentMethodName = (code) => {
        return _.find(RatingDownPaymentMethodDescriptionMap, { code: code }).desc;
    };

    const _getFullPayLabelForTermType = (termType) => {
        if (termType === "HalfYear") {
            return translator(messages.semiAnnualPayment);
        }
        return translator(messages.annualPayment);
    };

    const getSelectedPaymentPlanNameByCode = (planValue) => {
        switch (planValue) {
            case MLMortgageePayPlanPublicId:
                return translator(messages.ratingPaymentMethodMortgagee);
            case MLAnnuallyPayPlanPublicId:
                return translator(messages.annualPayment);
            case MLMonthlyPayPlanPublicId:
            case MLMonthlyAnnualResponsivePlanPublicId:
            case MLMonthlySemiAnnualResponsivePlanPublicId:
                return translator(messages.monthlyPayment);
            case MLTwicePerMonthPayPlanPublicId:
                return translator(messages.twicePerMonth);
            case MLTwoPayAnnualPlanPublicId:
            case MLTwoPaySemiAnnualPlanPublicId:
                return translator(messages.twoPay);
            case MLFourPayAnnualPlanPublicId:
                return translator(messages.fourPay);
            case MLPayrollDeductPlanPublicId:
                return translator(messages.payrollDeduct);
            default:
                return "";
        }
    };

    // from BaseQnbWizardCtrl.js
    const getBaseOfferingQuote = (offeredQuotes, chosenQuote) => {
        let chosenQuoteData = offeredQuotes.find(
            (quote) => quote.publicID === chosenQuote
        );
        if (chosenQuoteData.quoteBaseVersion_ML) {
            const baseOfferingQuoteVersion = offeredQuotes.find(
                (quote) => quote.publicID === chosenQuoteData.quoteBaseVersion_ML
            );
            chosenQuoteData = baseOfferingQuoteVersion || chosenQuoteData
        }
        return chosenQuoteData;
    };

    const getRecurringPlanPeriod = (chosenQuoteData) => {
        if (chosenQuoteData) {
            if (
                chosenQuoteData.ratingPaymentSchedule_ML ===
        MLRatingForMonthlyPayment.ratingPaymentSchedule_ML
            ) {
                return chosenQuoteData;
            }
            if (chosenQuoteData.others && chosenQuoteData.others.length > 0) {
                return chosenQuoteData.others.find(
                    (quote) =>
                        quote.ratingPaymentMethod_ML ===
              chosenQuoteData.ratingPaymentMethod_ML &&
            quote.ratingPaymentSchedule_ML ===
              MLRatingForMonthlyPayment.ratingPaymentSchedule_ML
                );
            }
            return chosenQuoteData;
        }
        return null;
    };

    const getAnnualPlanPeriodFromOthers = (chosenQuoteData) => {
        if (chosenQuoteData && chosenQuoteData.others) {
            return chosenQuoteData.others.find(
                (data) =>
                    data.ratingPaymentMethod_ML ===
          MLRatingForAnnualPayment.ratingPaymentMethod_ML
            );
        }
        return null;
    };

    const getMortgageePlanPeriodFromOthers = (chosenQuoteData) => {
        if (chosenQuoteData && chosenQuoteData.others) {
            return chosenQuoteData.others.find(
                (data) =>
                    data.ratingPaymentMethod_ML ===
          MLRatingForMortgageePayment.ratingPaymentMethod_ML
            );
        }
        return null;
    };

    const getRecurringPlanPeriodFromQuotes = (offeredQuotes, chosenQuote) => {
        const baseOfferingQuoteData = getBaseOfferingQuote(
            offeredQuotes,
            chosenQuote
        );
        return baseOfferingQuoteData;
    };

    const getAnnualPlanPeriodFromQuotes = (offeredQuotes, chosenQuote) => {
        const baseOffering = getBaseOfferingQuote(offeredQuotes, chosenQuote);
        let planPeriod;
        if (baseOffering.isCustom) {
            planPeriod = _.find(offeredQuotes, (quote) => {
                return (
                    quote.quoteBaseVersion_ML === baseOffering.publicID &&
          quote.ratingPaymentMethod_ML !==
            MLRatingForMortgageePayment.ratingPaymentMethod_ML &&
          quote.ratingPaymentSchedule_ML ===
            MLRatingForAnnualPayment.ratingPaymentSchedule_ML &&
          quote.isCustom === true
                );
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, (quote) => {
                    return (
                        quote.branchCode === baseOffering.branchCode &&
            quote.ratingPaymentMethod_ML !==
              MLRatingForMortgageePayment.ratingPaymentMethod_ML &&
            quote.ratingPaymentSchedule_ML ===
              MLRatingForAnnualPayment.ratingPaymentSchedule_ML &&
            quote.isCustom === true
                    );
                });
            }
        } else {
            planPeriod = _.find(offeredQuotes, (quote) => {
                return (
                    quote.quoteBaseVersion_ML === baseOffering.publicID &&
          quote.ratingPaymentMethod_ML !==
            MLRatingForMortgageePayment.ratingPaymentMethod_ML &&
          quote.ratingPaymentSchedule_ML ===
            MLRatingForAnnualPayment.ratingPaymentSchedule_ML
                );
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, (quote) => {
                    return (
                        quote.branchCode === baseOffering.branchCode &&
            quote.ratingPaymentMethod_ML !==
              MLRatingForMortgageePayment.ratingPaymentMethod_ML &&
            quote.ratingPaymentSchedule_ML ===
              MLRatingForAnnualPayment.ratingPaymentSchedule_ML
                    );
                });
            }
        }
        return planPeriod;
    };

    const getMortgageePlanPeriodFromQuotes = (
        offeredQuotes,
        chosenQuote,
        firstYear = false
    ) => {
        const baseOffering = getBaseOfferingQuote(offeredQuotes, chosenQuote);
        const correctPlanId = firstYear
            ? MLMortgageePayPlanPublicId
            : MLAnnuallyPayPlanPublicId;
        let planPeriod;
        if (baseOffering.isCustom) {
            planPeriod = offeredQuotes.find(
                (quote) =>
                    quote.quoteBaseVersion_ML === baseOffering.publicID &&
          quote.ratingPaymentMethod_ML ===
            MLRatingForMortgageePayment.ratingPaymentMethod_ML &&
          quote.ratingPaymentSchedule_ML ===
            MLRatingForMortgageePayment.ratingPaymentSchedule_ML &&
          quote.isCustom === true &&
          quote.paymentPlans_ML.find((pp) => pp.billingId === correctPlanId)
            );

            if (!planPeriod) {
                planPeriod = offeredQuotes.find(
                    (quote) =>
                        quote.branchCode === baseOffering.branchCode &&
                        quote.publicID === baseOffering.publicID &&
            quote.ratingPaymentMethod_ML ===
              MLRatingForMortgageePayment.ratingPaymentMethod_ML &&
            quote.ratingPaymentSchedule_ML ===
              MLRatingForMortgageePayment.ratingPaymentSchedule_ML &&
            quote.isCustom === true &&
            quote.paymentPlans_ML.find((pp) => pp.billingId === correctPlanId)
                );
            }
        } else {
            planPeriod = offeredQuotes.find(
                (quote) =>
                    quote.quoteBaseVersion_ML === baseOffering.publicID &&
          quote.ratingPaymentMethod_ML ===
            MLRatingForMortgageePayment.ratingPaymentMethod_ML &&
          quote.ratingPaymentSchedule_ML ===
            MLRatingForMortgageePayment.ratingPaymentSchedule_ML &&
          quote.paymentPlans_ML.find((pp) => pp.billingId === correctPlanId)
            );

            if (!planPeriod) {
                planPeriod = offeredQuotes.find(
                    (quote) =>
                        quote.branchCode === baseOffering.branchCode &&
                    quote.publicID === baseOffering.publicID &&
            quote.ratingPaymentMethod_ML ===
              MLRatingForMortgageePayment.ratingPaymentMethod_ML &&
            quote.ratingPaymentSchedule_ML ===
              MLRatingForMortgageePayment.ratingPaymentSchedule_ML &&
            quote.paymentPlans_ML.find((pp) => pp.billingId === correctPlanId)
                );
            }
        }
        return planPeriod;
    };

    const getMonthlyPayrollDeductPlanPeriodFromQuotes = (
        offeredQuotes,
        chosenQuote
    ) => {
        const baseOffering = getBaseOfferingQuote(offeredQuotes, chosenQuote);
        let planPeriod;
        if (baseOffering.isCustom) {
            planPeriod = _.find(offeredQuotes, {
                quoteBaseVersion_ML: baseOffering.publicID,
                ratingPaymentMethod_ML:
          MLRatingForMonthlyPayrollDeductPayment.ratingPaymentMethod_ML,
                ratingPaymentSchedule_ML:
          MLRatingForMonthlyPayrollDeductPayment.ratingPaymentSchedule_ML,
                isCustom: true,
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, {
                    branchCode: baseOffering.branchCode,
                    publicID: baseOffering.publicID,
                    ratingPaymentMethod_ML:
            MLRatingForMonthlyPayrollDeductPayment.ratingPaymentMethod_ML,
                    ratingPaymentSchedule_ML:
            MLRatingForMonthlyPayrollDeductPayment.ratingPaymentSchedule_ML,
                    isCustom: true,
                });
            }
        } else {
            planPeriod = _.find(offeredQuotes, {
                quoteBaseVersion_ML: baseOffering.publicID,
                ratingPaymentMethod_ML:
          MLRatingForMonthlyPayrollDeductPayment.ratingPaymentMethod_ML,
                ratingPaymentSchedule_ML:
          MLRatingForMonthlyPayrollDeductPayment.ratingPaymentSchedule_ML,
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, {
                    branchCode: baseOffering.branchCode,
                    publicID: baseOffering.publicID,
                    ratingPaymentMethod_ML:
            MLRatingForMonthlyPayrollDeductPayment.ratingPaymentMethod_ML,
                    ratingPaymentSchedule_ML:
            MLRatingForMonthlyPayrollDeductPayment.ratingPaymentSchedule_ML,
                });
            }
        }
        return planPeriod;
    };

    const getAnnualPayrollDeductPlanPeriodFromQuotes = (
        offeredQuotes,
        chosenQuote
    ) => {
        const baseOffering = getBaseOfferingQuote(offeredQuotes, chosenQuote);
        let planPeriod;
        if (baseOffering.isCustom) {
            planPeriod = _.find(offeredQuotes, {
                quoteBaseVersion_ML: baseOffering.publicID,
                ratingPaymentMethod_ML:
          MLRatingForAnnualPayrollDeductPayment.ratingPaymentMethod_ML,
                ratingPaymentSchedule_ML:
          MLRatingForAnnualPayrollDeductPayment.ratingPaymentSchedule_ML,
                isCustom: true,
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, {
                    branchCode: baseOffering.branchCode,
                    publicID: baseOffering.publicID,
                    ratingPaymentMethod_ML:
            MLRatingForAnnualPayrollDeductPayment.ratingPaymentMethod_ML,
                    ratingPaymentSchedule_ML:
            MLRatingForAnnualPayrollDeductPayment.ratingPaymentSchedule_ML,
                    isCustom: true,
                });
            }
        } else {
            planPeriod = _.find(offeredQuotes, {
                quoteBaseVersion_ML: baseOffering.publicID,
                ratingPaymentMethod_ML:
          MLRatingForAnnualPayrollDeductPayment.ratingPaymentMethod_ML,
                ratingPaymentSchedule_ML:
          MLRatingForAnnualPayrollDeductPayment.ratingPaymentSchedule_ML,
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, {
                    branchCode: baseOffering.branchCode,
                    publicID: baseOffering.publicID,
                    ratingPaymentMethod_ML:
            MLRatingForAnnualPayrollDeductPayment.ratingPaymentMethod_ML,
                    ratingPaymentSchedule_ML:
            MLRatingForAnnualPayrollDeductPayment.ratingPaymentSchedule_ML,
                });
            }
        }
        return planPeriod;
    };

    const getFullPayPlanPeriodFromQuotes = (
        offeredQuotes,
        ratingPaymentMethod,
        chosenQuote
    ) => {
        const baseOffering = getBaseOfferingQuote(offeredQuotes, chosenQuote);
        let planPeriod;
        if (baseOffering.isCustom) {
            planPeriod = _.find(offeredQuotes, {
                quoteBaseVersion_ML: baseOffering.publicID,
                ratingPaymentMethod_ML: ratingPaymentMethod,
                ratingPaymentSchedule_ML: "full_pay",
                isCustom: true,
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, {
                    branchCode: baseOffering.branchCode,
                    publicID: baseOffering.publicID,
                    ratingPaymentMethod_ML: ratingPaymentMethod,
                    ratingPaymentSchedule_ML: "full_pay",
                    isCustom: true,
                });
            }
        } else {
            planPeriod = _.find(offeredQuotes, {
                quoteBaseVersion_ML: baseOffering.publicID,
                ratingPaymentMethod_ML: ratingPaymentMethod,
                ratingPaymentSchedule_ML: "full_pay",
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, {
                    branchCode: baseOffering.branchCode,
                    publicID: baseOffering.publicID,
                    ratingPaymentMethod_ML: ratingPaymentMethod,
                    ratingPaymentSchedule_ML: "full_pay",
                });
            }
        }
        return planPeriod;
    };

    const getInstallmentsPlanPeriodFromQuotes = (
        offeredQuotes,
        ratingPaymentMethod,
        chosenQuote
    ) => {
        const baseOffering = getBaseOfferingQuote(offeredQuotes, chosenQuote);
        let planPeriod;
        if (baseOffering.isCustom) {
            planPeriod = _.find(offeredQuotes, {
                quoteBaseVersion_ML: baseOffering.publicID,
                ratingPaymentMethod_ML: ratingPaymentMethod,
                ratingPaymentSchedule_ML: "installments",
                isCustom: true,
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, {
                    branchCode: baseOffering.branchCode,
                    publicID: baseOffering.publicID,
                    ratingPaymentMethod_ML: ratingPaymentMethod,
                    ratingPaymentSchedule_ML: "installments",
                    isCustom: true,
                });
            }
        } else {
            planPeriod = _.find(offeredQuotes, {
                quoteBaseVersion_ML: baseOffering.publicID,
                ratingPaymentMethod_ML: ratingPaymentMethod,
                ratingPaymentSchedule_ML: "installments",
            });
            if (!planPeriod) {
                planPeriod = _.find(offeredQuotes, {
                    branchCode: baseOffering.branchCode,
                    publicID: baseOffering.publicID,
                    ratingPaymentMethod_ML: ratingPaymentMethod,
                    ratingPaymentSchedule_ML: "installments",
                });
            }
        }
        return planPeriod;
    };

    const getChosenQuoteDataFromQuotes = (offeredQuotes, chosenQuote) => {
        return _.find(offeredQuotes, { publicID: chosenQuote });
    };

    const _getLatestTermNumber = (policyTerms) => {
        const termNumbers = policyTerms.map((policy) => policy.termNumber_ML);
        return Math.max(...termNumbers);
    };

    const _getPreviousTermsWithRemainingBalance = (policyTerms) => {
        const latestTerm = _getLatestTermNumber(policyTerms);
        return policyTerms.filter((policy) => (policy.remainingPolicyBalance_ML.amount > 0 && policy.termNumber_ML !== latestTerm));
    };

    const _getPreviousTermsWithOutstandingBalance = (policyTerms) => {
        const latestTerm = _getLatestTermNumber(policyTerms);
        return policyTerms.filter((policy) => (policy.totalOutstandingAmount_ML.amount > 0 && policy.termNumber_ML !== latestTerm));
    };


    return {
        getPaymentMethodName: _getPaymentMethodName,
        getDownPaymentMethodName: _getDownPaymentMethodName,
        getRatingPaymentMethods: _getRatingPaymentMethods,
        getAccountPaymentMethods: _getAccountPaymentMethods,
        getPaymentChannels: _getPaymentChannels,
        getFullPayLabelForTermType: _getFullPayLabelForTermType,
        //
        getBaseOfferingQuote: getBaseOfferingQuote,
        getRecurringPlanPeriod: getRecurringPlanPeriod,
        getAnnualPlanPeriodFromOthers: getAnnualPlanPeriodFromOthers,
        getMortgageePlanPeriodFromOthers: getMortgageePlanPeriodFromOthers,
        getRecurringPlanPeriodFromQuotes: getRecurringPlanPeriodFromQuotes,
        getAnnualPlanPeriodFromQuotes: getAnnualPlanPeriodFromQuotes,
        getMortgageePlanPeriodFromQuotes: getMortgageePlanPeriodFromQuotes,
        getMonthlyPayrollDeductPlanPeriodFromQuotes: getMonthlyPayrollDeductPlanPeriodFromQuotes,
        getAnnualPayrollDeductPlanPeriodFromQuotes: getAnnualPayrollDeductPlanPeriodFromQuotes,
        getFullPayPlanPeriodFromQuotes: getFullPayPlanPeriodFromQuotes,
        getInstallmentsPlanPeriodFromQuotes: getInstallmentsPlanPeriodFromQuotes,
        getChosenQuoteDataFromQuotes: getChosenQuoteDataFromQuotes,
        getSelectedPaymentPlanNameByCode,
        getLatestTermNumber: _getLatestTermNumber,
        getPreviousTermsWithRemainingBalance: _getPreviousTermsWithRemainingBalance,
        getPreviousTermsWithOutstandingBalance: _getPreviousTermsWithOutstandingBalance
    };
}

export default MLBillingUtil;
